const allMemberStatuses = [
    'active',
    'invited',
    'pending',
    'deleted'
];
const allMemberStatusesSet = new Set(allMemberStatuses);

export { allMemberStatuses, allMemberStatusesSet };
//# sourceMappingURL=MemberStatus.mjs.map
